import { INoteDTO } from '@/dtos';
import { get, post, remove } from '@/services/apiWrapper';

export const getNotesForTeamYearAPI = async (
  teamCriteriaId: string,
): Promise<{ data: INoteDTO[]; count: number }> => {
  const notes = await get<{ data: INoteDTO[]; count: number }>(`/admin/notes/${teamCriteriaId}`);
  return notes;
};

export const createNoteAPI = async (teamCriteriaId: string, body: INoteDTO): Promise<INoteDTO> => {
  const notes = await post<INoteDTO>(`/admin/notes/${teamCriteriaId}`, body);
  return notes;
};

export const updateNoteAPI = async (body: INoteDTO): Promise<INoteDTO> => {
  const result = await post<INoteDTO>(`/admin/note/${body.id}`, body);
  return result;
};

export const deleteNoteAPI = async (noteId: string): Promise<boolean> => {
  const result = await remove<boolean>(`/admin/note/${noteId}`);
  return result;
};
